import ajax, { handleRedirect } from 'helpers/ajax';
import Routes from 'apps/portal/routes.erb';
import { handleRejectedRequest } from 'helpers/form';
import { fieldsLabels } from './components/forgot-password-form/validate';

export function submit(payload) {
  return () => ajax({
    url: Routes.identity_password_path({ format: 'json' }),
    method: 'POST',
    data: { identity: payload },
  }, null, { hideDefaultErrorNotification: true })
    .then(handleRedirect)
    .catch(handleRejectedRequest(fieldsLabels));
}
